import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter, useParams} from 'react-router-dom';
import {useHistory} from 'react-router-dom';
import dayjs from 'dayjs';

import {
    Table, Button, Radio, message, Modal, Form,
    Input, Select, TimePicker, Checkbox
} from 'antd';
import {
    LeftOutlined,
    ExclamationCircleOutlined,
    ExclamationCircleFilled
} from '@ant-design/icons';

import {
    fetchDataReviewDetail, fetchReviewDetailUpdate, fetchReviewCheckThrough,
    fetchReviewFilterList
} from '../../actions/dataReview';
import {
    machineReviewFormatter, getPhoneAreaInvalid, getPhoneException,
    selectStatusFilter, verifyStatusOptions, weekOption, weekVerify, checkSelectOptions
} from './utils';
import RegionComp from '../../components/RegionComp';
import TagComp from '../../components/TagComp';

import './dataReviewDetail.less';

interface IUrlProps {
    pageType: string;
    pageId: string;
    cardType: string;
}
interface IReviewDetailProps {
    fetchDataReviewDetail: (params: any) => Promise<any>;
    fetchDetailUpdate: (id, params: any) => Promise<any>;
    fetchCheckThrough: (id, params: any) => Promise<any>;
    fetchFilterList: (params: any) => Promise<any>;
}

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const RangePicker = TimePicker.RangePicker;
const {confirm} = Modal;
export function DataReviewDetail(props: IReviewDetailProps) {
    const {fetchDataReviewDetail, fetchDetailUpdate, fetchCheckThrough, fetchFilterList} = props;
    const [form] = Form.useForm();
    const history = useHistory();
    const {pageType, cardType, pageId} = useParams<IUrlProps>();

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(1);

    const [dataDetail, setDataDetail] = useState<any>({});
    const [tableData, setTableData] = useState<any>([]);
    const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [isEditDialogVisible, setIsEditDialogVisible] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>({});
    const [areaSelectedValue, setAreaSelectedValue] = useState({
        province: null,
        city: null,
        district: null,
        town: null
    });

    const [provCityOptions, setProvCityOptions] = useState<any>([]);
    const [provCity, setProvCity] = useState('');
    const [cateSelectOptions, setCateSelectOptions] = useState<any>([]);
    const [cateSelect, setCateSelect] = useState('');
    const [numSelect, setNumSelect] = useState('全部');
    const [checkSelect, setCheckSelect] = useState('-1');

    useEffect(() => {
        fetchDataDetail();
        getFilterList();
    }, [pageId]);

    const getFilterList = async () => {
        const param = {
            import_id: pageId
        };
        const res = await fetchFilterList(param);
        if (res?.code === 200) {
            if (res.data?.city?.length > 0) {
                const tempCity = res.data.city.map(item => {
                    return {
                        value: item,
                        label: item
                    };
                });
                setProvCityOptions(tempCity);
            }
            if (res.data?.category?.length > 0) {
                const tempCategory = res.data.category.map(item => {
                    return {
                        value: item,
                        label: item
                    };
                });
                setCateSelectOptions(tempCategory);
            }
        }
    };

    const fetchDataDetail = (initialParam?: any) => {
        const param = {
            page: initialParam?.page || pageCurrent,
            size: initialParam?.size || pageSize,
            import_id: pageId,
            phone_number: initialParam?.numSelect || numSelect,
            verify_status: initialParam?.checkSelect || checkSelect,
            city: initialParam?.provCity || provCity,
            cateSelect: initialParam?.cateSelect || cateSelect,
        };
        setTableLoading(true);
        fetchDataReviewDetail(param)
            .then(res => {
                if (res?.code === 200) {
                    const tempData = res.data;
                    const tempDataList = tempData.list;
                    tempDataList.map(item => {
                        if (item.phone_list && item.phone_list.length > 0) {
                            item.phone_list.forEach(phoneItem => {
                                if (phoneItem.data_source) {
                                    const dataSource = JSON.parse(phoneItem.data_source);
                                    phoneItem.dataSourceName = dataSource.name;
                                    phoneItem.dataSourceLink = dataSource.link;
                                }
                                if (!phoneItem.phone_number) {
                                    phoneItem.selectNoNumResult = phoneItem.no_phone_number === 1;
                                    // 未审核状态下，无号码+数据来源为官网需要默认选中无号码卡
                                    if (phoneItem.verify_status === 0 && phoneItem.dataSourceName === '官网') {
                                        phoneItem.selectNoNumResult = true;
                                    }
                                }
                                phoneItem.verifyResult = phoneItem.verify_status;
                            });
                        }
                    });
                    setDataDetail(res.data);
                    setTableData(tempDataList);
                    setTableLoading(false);
                } else {
                    message.error(res.message || '获取数据失败');
                    setTableLoading(false);
                }
            })
            .catch(() => {
                message.error('数据获取失败');
                setTableLoading(false);
            });
    };
    /* eslint-enable */
    const onVerifySubmit = (value, scope, tableRow) => {
        const selectYesIds: number[] = [];
        const selectNoIds: number[] = [];
        const selectNoPhoneNumber: number[] = [];
        const selectNoNoPhoneNumber: number[] = [];
        if (value === 1) {
            selectYesIds.push(scope.id);
            if (!scope.phone_number) {
                selectNoPhoneNumber.push(scope.id);
            }
        }
        if (value === 2) {
            selectNoIds.push(scope.id);
            if (!scope.phone_number && !scope.selectNoNumResult) {
                selectNoNoPhoneNumber.push(scope.id);
            } else if (!scope.phone_number && scope.selectNoNumResult) {
                selectNoPhoneNumber.push(scope.id);
            }
        }
        const params = {
            select_yes_ids: selectYesIds,
            select_no_ids: selectNoIds,
            select_yes_no_phone_number: selectNoPhoneNumber,
            select_no_no_phone_number: selectNoNoPhoneNumber
        };
        fetchCheckThrough(pageId, params).then(res => {
            if (res?.code === 200) {
                message.success('审核提交成功');
                const itemIndex = scope.itemIndex;
                const tableRowIndex = tableRow.tableRowIndex;
                if (tableData[tableRowIndex] && tableData[tableRowIndex].phone_list) {
                    tableData[tableRowIndex].phone_list[itemIndex].verifyResult = value;
                }
                setTableData([...tableData]);
                fetchDataDetail();
            }
        });
    };
    const onCheckNoNumResult = (e, scope, tableRow) => {
        const checkValue = e.target.checked;
        const itemIndex = scope.itemIndex;
        const tableRowIndex = tableRow.tableRowIndex;
        if (tableData[tableRowIndex] && tableData[tableRowIndex].phone_list) {
            tableData[tableRowIndex].phone_list[itemIndex].selectNoNumResult = checkValue;
        }
        setTableData([...tableData]);
    };
    const onVerifyRadioChange = (e, scope, tableRow) => {
        const radioValue = e.target.value;
        let isRequiredEmpty = false;
        let isLengthExceed = false;
        let warnText = '';

        if (radioValue === 1) {
            // 选择审核通过时需要校验词槽、单卡name、title简称、单卡title必填
            if (!tableRow.word_slot || !scope.online_name || !tableRow.title_similar || !tableRow.online_title) {
                isRequiredEmpty = true;
            }
            if (tableRow.online_title && tableRow.online_title.length > 100) {
                isLengthExceed = true;
            }
            // 如果是组卡类型，需要校验组卡名称和类别必填
            if (cardType === 'group' && (!tableRow.show_name || !tableRow.category)) {
                message.warning('请检查必填项！');
                return;
            }
            // 审核通过时需要校验区号：
            // exception： 1：未提供区号  2：号段异常
            // code_area_invalid  : 1: 区号和地址不匹配
            if (scope.code_area_invalid === 1) {
                warnText = '该号码为异常号码，请确认号码是否正确后再通过审核。';
            }
            if (scope.exception === 1 || scope.exception === 2) {
                warnText = scope.exception === 1
                    ? '该座机号未提供区号，请确认号码是否正确后再通过审核。'
                    : '该号码为异常号码，请确认号码是否正确后再通过审核。';
            }
        }
        if (isRequiredEmpty) {
            message.warning('请检查必填项！');
            return;
        }
        if (isLengthExceed) {
            message.warning('单卡title长度不能超过100个字符！');
            return;
        }
        // 区号异常or号段异常
        if (warnText) {
            Modal.confirm({
                title: '提示',
                content: warnText,
                icon: <ExclamationCircleOutlined />,
                okText: '确认并通过',
                cancelText: '取消',
                onOk() {
                    onVerifySubmit(radioValue, scope, tableRow);
                },
                onCancel() {},
            });
        } else {
            onVerifySubmit(radioValue, scope, tableRow);
        }
    };
    const getColumns = () => {
        const tempColumns = [] as any;
        if (pageType === '1') {
            tempColumns.push({
                title: '抓取title',
                dataIndex: 'grab_title',
                key: 'grab_title',
                render: (text) => {
                    return text || '-';
                }
            });
        } else if (pageType === '2') {
            tempColumns.push({
                title: '品牌',
                dataIndex: 'brand',
                key: 'brand',
            }, {
                title: '公司名称',
                dataIndex: 'company',
                key: 'company',
            });
        }
        tempColumns.push({
            title: '地址',
            dataIndex: 'address',
            key: 'address',
            render: (text) => {
                return text || '-';
            }
        }, {
            title: '省',
            dataIndex: 'province',
            key: 'province',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '市',
            dataIndex: 'city',
            key: 'city',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '区/县',
            dataIndex: 'district',
            key: 'district',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '街道/乡镇',
            dataIndex: 'town',
            key: 'town',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '杂质点',
            dataIndex: 'location',
            key: 'location',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '单卡title',
            dataIndex: 'online_title',
            key: 'online_title',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: 'title简称',
            dataIndex: 'title_similar',
            key: 'title_similar',
            render: (text) => {
                return text || '-';
            }
        }, {
            title: '动态核心词',
            dataIndex: 'dynamic_word',
            key: 'dynamic_word',
            render: (text) => {
                return text || '-';
            }
        }, {
            title: '组卡name',
            dataIndex: 'show_name',
            key: 'show_name',
            render: (text) => {
                return text || '-';
            }
        }, {
            title: '类别',
            dataIndex: 'category',
            key: 'category',
            render: (text) => {
                return text || '-';
            }
        }, {
            title: '词槽',
            dataIndex: 'word_slot',
            key: 'word_slot',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '科室',
            dataIndex: 'brand_class',
            key: 'brand_class',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {text || '-'}
                </div>);
            }
        }, {
            title: '机审结果',
            dataIndex: 'geo_ner_check',
            key: 'geo_ner_check',
            render: (text, item) => {
                return (<div className={item.geo_ner_check === '0' ? 'red' : ''}>
                    {machineReviewFormatter(text)}
                </div>);
            }
        }, {
            title: '',
            dataIndex: '',
            width: '800px',
            render: (_, tableItem, tableRowIndex) => {
                return (<Table
                    dataSource={tableItem.phone_list}
                    pagination={false}
                    className="inline-table"
                    bordered
                    rowKey="id"
                    columns={[
                        {
                            title: '号码',
                            dataIndex: 'phone_number',
                            key: 'phone_number',
                            width: 90,
                            render: (text, item) => {
                                if (!text) {
                                    return <div className="red">无号码</div>;
                                }
                                return (<div
                                    className={(item.exception === 1
                                        || item.exception === 2
                                        || item.code_area_invalid === 1
                                    )
                                        ? 'red phone-number-row'
                                        : 'phone-number-row'
                                    }
                                >
                                    <div>{text}</div>
                                    <div>
                                        {getPhoneException(item.exception)
                                            || getPhoneAreaInvalid(item.code_area_invalid)
                                        }
                                    </div>
                                </div>);
                            }
                        }, {
                            title: '抓取name',
                            dataIndex: 'grab_name',
                            key: 'grab_name',
                            width: 90,
                            render: (text) => {
                                return text || '-';
                            }
                        }, {
                            title: '单卡name',
                            dataIndex: 'online_name',
                            key: 'online_name',
                            width: 90,
                            render: (text) => {
                                return text || '-';
                            }
                        }, {
                            title: '服务时间',
                            dataIndex: 'open_time',
                            key: 'open_time',
                            width: 90,
                            render: (text, item) => {
                                return (<div className={item.open_time_invalid === 1 ? 'red' : ''}>
                                    {text || '-'}
                                </div>);
                            }
                        }, {
                            title: '数据来源',
                            dataIndex: 'data_source',
                            key: 'data_source',
                            width: 100,
                            render: (text) => {
                                if (text) {
                                    const dataSource = JSON.parse(text);
                                    const dataSourceName = dataSource.name;
                                    const dataSourceLink = dataSource.link;
                                    return <div>
                                        {dataSourceLink
                                            ? <a
                                                href={dataSourceLink}
                                                style={{color: '#00e', textDecoration: 'underline'}}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {dataSourceName}
                                            </a>
                                            : dataSourceName
                                        }
                                    </div>;
                                }
                                return '-';
                            }
                        }, {
                            title: '审核状态',
                            dataIndex: 'verify_status',
                            key: 'verify_status',
                            width: '200px',
                            render: (_, item, itemIndex) => {
                                if (dataDetail.status === 0 || dataDetail.status === 1 || dataDetail.status === 2) {
                                    return <div>
                                        <RadioGroup
                                            onChange={
                                                (e) => onVerifyRadioChange(
                                                    e,
                                                    {...item, itemIndex},
                                                    {...tableItem, tableRowIndex})
                                            }
                                            value={item.verifyResult}
                                        >
                                            <Radio value={1}>通过</Radio>
                                            <Radio value={2}>不通过</Radio>
                                        </RadioGroup>
                                        {!item.phone_number && <div>
                                            <div className="divider"></div>
                                            <Checkbox
                                                checked={item.selectNoNumResult}
                                                onChange={e => onCheckNoNumResult(
                                                    e,
                                                    {...item, itemIndex},
                                                    {...tableItem, tableRowIndex}
                                                )}
                                            >
                                                无号码卡
                                            </Checkbox>
                                        </div>}
                                    </div>;
                                } else {
                                    return (<div className={item.verifyResult + '' === '1' ? 'green' : 'gray'}>
                                        {verifyStatusOptions(item.verifyResult)}
                                    </div>);
                                }
                            }
                        }, {
                            title: '操作',
                            dataIndex: 'options',
                            key: 'options',
                            render: (_, item) => {
                                if (dataDetail.status === 0 || dataDetail.status === 1 || dataDetail.status === 2) {
                                    return <Button type="link" onClick={() => onItemEdit(item, tableItem)}>
                                        编辑
                                    </Button>;
                                }
                                return '-';
                            }
                        }
                    ]}
                />);
            }
        });
        return tempColumns;
    };

    const onItemEdit = (item, tableItem) => {
        setIsEditDialogVisible(true);

        let weekStart = '';
        let weekEnd = '';
        let startTime: any = [];
        let endTime: any = [];
        let connectTimeValue: unknown = null;

        if (item.open_time) {
            // 标准时间格式为：周一至周五 00:00-24:00
            const openTime = item.open_time;
            const weekArr = openTime.split('至');
            if (weekArr.length === 2) {
                weekStart = weekArr[0];
                weekEnd = weekArr[1].substring(0, 2);
                // 去掉周五+空格 三个字符，获得时间范围
                const timeRange = weekArr[1].slice(3);
                if (timeRange) {
                    const timeArr = timeRange.split('-');
                    // 获取开始时间和结束时间
                    if (timeArr.length === 2) {
                        startTime = timeArr[0].split(':');
                        endTime = timeArr[1].split(':');
                        if (startTime && startTime.length === 2 && endTime && endTime.length === 2) {
                            // 时和分的位数不可能超过2位
                            if (startTime[0].length < 3
                                && startTime[1].length < 3
                                && endTime[0].length < 3
                                && endTime[1].length < 3
                            ) {
                                connectTimeValue = [
                                    dayjs(new Date(2024, 8, 14, startTime[0], startTime[1]), 'HH:mm'),
                                    dayjs(new Date(2024, 8, 14, endTime[0], endTime[1]), 'HH:mm'),
                                ];
                            }
                        }
                    }
                }
            }
        }

        const tempAreaSelectedValue = {
            province: tableItem.province || null,
            city: tableItem.city || null,
            district: tableItem.district || null,
            town: tableItem.town || null
        };


        const tempEditData = {
            ...item,
            ...tableItem,
            weekStart: weekStart,
            weekEnd: weekEnd,
            connectTimeValue,
        };

        if (item.data_source) {
            const dataSource = JSON.parse(item.data_source);
            tempEditData.dataSourceName = dataSource.name;
            tempEditData.dataSourceLink = dataSource.link;
        }
        setEditData(tempEditData);
        form.setFieldsValue(tempEditData);
        setAreaSelectedValue({...tempAreaSelectedValue});
    };
    const onPageChange = (page, size) => {
        if (page !== pageCurrent) {
            setPageCurrent(page);
            fetchDataDetail({page});
        }
        if (size !== pageSize) {
            setPageSize(size);
            setPageCurrent(1);
            fetchDataDetail({page: 1, size: pageSize});
        }
    };
    const backPage = () => {
        history.push('/data_review');
    };
    const onEditSubmit = (value) => {
        const {
            address, brand_class, category, phone_number, weekStart, weekEnd, word_slot,
            online_name, title_similar, connectTimeValue, online_title, show_name, dynamic_word,
            grab_name, location, dataSourceLink, verifyResult, brand

        } = value;
        const {exception, code_area_invalid} = editData;

        let openTime = '';
        if (weekStart || weekEnd || (connectTimeValue && connectTimeValue.length > 0)) {
            if (weekStart && weekEnd && connectTimeValue && connectTimeValue.length > 0) {
                const weekStartValue = weekVerify(weekStart);
                const weekEndValue = weekVerify(weekEnd);
                // 正常会返回周几的数字值，异常会返回0
                if (weekStartValue === 0 || weekEndValue === 0) {
                    message.error('服务时间格式错误，请修改！');
                    return;
                }
                if (weekEndValue < weekStartValue) {
                    message.error('服务时间结束时间不能小于开始时间！');
                    return;
                }
                const timeStart = dayjs(connectTimeValue[0]).format('HH:mm');
                const timeEnd = dayjs(connectTimeValue[1]).format('HH:mm');
                if (timeStart === 'Invalid Date' || timeEnd === 'Invalid Date') {
                    message.error('服务时间格式错误，请修改！');
                    return;
                }
                const timeStartNumber = timeStart.replace(':', '');
                const timeEndNumber = timeEnd.replace(':', '');

                if (timeEndNumber < timeStartNumber) {
                    message.error('服务时间结束时间不能小于开始时间！');
                    return;
                }
                openTime = `${weekStart}至${weekEnd} ${timeStart}-${timeEnd}`;

            } else {
                message.error('服务时间格式错误！');
                return;
            }
        }
        // 词槽、单卡name、title简称、单卡title 必填校验
        if (!word_slot || !online_name || !title_similar || !online_title) {
            message.error('请检查必填项！');
            return;
        }

        // 如果是组卡类型，需要校验组卡名称和类别必填
        if (cardType === 'group' && (!show_name || !category)) {
            message.error('请检查必填项！');
            return;
        }
        // 数据来源为官网时，官网链接必填
        if (editData.dataSourceName === '官网' && !dataSourceLink) {
            message.error('请检查必填项！');
            return;
        }
        if (online_title && online_title.length > 100) {
            message.error('单卡title长度不能超过100个字符！');
            return;
        }

        if (phone_number) {
            // 判断中文
            const reg = /[\u4e00-\u9fa5]+/g;
            if (phone_number.match(reg)) {
                message.error('号码非法，请确认');
                return;
            }
        }
        const handleSubmit = async () => {
            const param: any = {
                id: editData.id,
                address: address,
                phone_number: phone_number || '',
                grab_name: grab_name,
                online_name: online_name,
                online_title: online_title,
                title_similar: title_similar,
                dynamic_word: dynamic_word,
                word_slot: word_slot,
                verify_status: verifyResult,
                group_id: editData.group_id,
                province: areaSelectedValue.province,
                city: areaSelectedValue.city,
                district: areaSelectedValue.district,
                town: areaSelectedValue.town,
                location: location,
                open_time: openTime,
                category: category,
                show_name: show_name,
                brand_class: brand_class
            };
            if (pageType === '2') {
                param.brand = brand;
                param.company = editData.company;
            }
            // 数据来源为官网时，官网链接必填
            if (editData.dataSourceName === '官网') {
                param.data_source = {
                    name: editData.dataSourceName,
                    link: dataSourceLink
                };
            }
            // 如果选中审核通过，且为无号码卡，需要默认勾选无号码卡
            if (verifyResult === 1 && !phone_number) {
                param.no_phone_number = 1;
            }
            const data = await fetchDetailUpdate(pageId, param);
            if (data?.code === 200) {
                message.success('编辑成功');
                setIsEditDialogVisible(false);
                fetchDataDetail();
            }
        };

        // exception: 1 未提供区号 2 异常号码  code_area_invalid：区号和地址不匹配
        if (
            (exception === 1 || exception === 2 || code_area_invalid === 1)
            && verifyResult === 1
        ) {
            let warnText = '';
            if (code_area_invalid === 1) {
                warnText = '该号码为异常号码，请确认号码是否正确后再通过审核。';
            }
            if (exception === 1 || exception === 2) {
                warnText = exception === 1
                    ? '该座机号未提供区号，请确认号码是否正确后再通过审核。'
                    : '该号码为异常号码，请确认号码是否正确后再通过审核。';
            }
            confirm({
                title: '提示',
                icon: <ExclamationCircleFilled />,
                content: warnText,
                onOk() {
                    handleSubmit();
                }
            });
        } else {
            handleSubmit();
        }


    };
    const handleEditCancel = () => {
        setIsEditDialogVisible(false);
        form.resetFields();
    };
    const updateTagList = (value) => {
        editData.word_slot = value.trim();
        setEditData({...editData});
        form.setFieldsValue({'word_slot': value});
    };
    const updateDynamicWord = (value) => {
        editData.dynamic_word = value.trim();
        setEditData({...editData});
        form.setFieldsValue({'dynamic_word': value});
    };
    const onRegionChange = (value, type) => {
        const tempAreaSelectedValue = {...areaSelectedValue};
        if (type === 'province') {
            tempAreaSelectedValue.province = value;
            tempAreaSelectedValue.city = null;
            tempAreaSelectedValue.district = null;
            tempAreaSelectedValue.town = null;
        } else if (type === 'city') {
            tempAreaSelectedValue.city = value;
            tempAreaSelectedValue.district = null;
            tempAreaSelectedValue.town = null;
        } else if (type === 'area') {
            tempAreaSelectedValue.district = value;
            tempAreaSelectedValue.town = null;
        } else if (type === 'town') {
            tempAreaSelectedValue.town = value;
        }
        setAreaSelectedValue({...tempAreaSelectedValue});
    };
    const onRegionClear = () => {
        const tempAreaSelectedValue = {...areaSelectedValue};
        tempAreaSelectedValue.province = null;
        tempAreaSelectedValue.city = null;
        tempAreaSelectedValue.district = null;
        tempAreaSelectedValue.town = null;

        setAreaSelectedValue({...tempAreaSelectedValue});
    };

    const selectChange = (e, type) => {
        if (type === 'provCity') {
            setProvCity(e);
            setPageCurrent(1);
            fetchDataDetail({provCity: e, page: 1});
        } else if (type === 'cateSelect') {
            setCateSelect(e);
            setPageCurrent(1);
            fetchDataDetail({cateSelect: e, page: 1});
        } else if (type === 'numSelect') {
            setNumSelect(e);
            setPageCurrent(1);
            fetchDataDetail({numSelect: e, page: 1});
        } else if (type === 'checkSelect') {
            setCheckSelect(e);
            setPageCurrent(1);
            fetchDataDetail({checkSelect: e, page: 1});
        }
    };

    const sendAllPass = () => {
        const allIds = [] as any;
        const allNoPhoneNumber = [] as any;

        let passFlag = true;
        let isLengthExceed = false;
        let isPhoneInvalid = false;

        tableData.forEach(item => {
            if (!item.word_slot || !item.title_similar || !item.online_title) {
                passFlag = false;
            }
            if (item.online_title && item.online_title.length > 100) {
                isLengthExceed = true;
            }
            if (cardType === 'group' && (!item.show_name || !item.category)) {
                passFlag = false;
            }
            if (item.phone_list && item.phone_list.length > 0) {
                item.phone_list.forEach((phoneItem: {
                    id: number,
                    phone_number: string,
                    online_name: string,
                    exception: number,
                    code_area_invalid: number
                }) => {
                    allIds.push(phoneItem.id);
                    if (!phoneItem.phone_number) {
                        allNoPhoneNumber.push(phoneItem.id);
                    }
                    if (!phoneItem.online_name) {
                        passFlag = false;
                    }
                    if (phoneItem.exception === 1
                        || phoneItem.exception === 2
                        || phoneItem.code_area_invalid === 1
                    ) {
                        isPhoneInvalid = true;
                    }
                });
            }

        });

        if (!passFlag) {
            message.warning('存在未填写数据，请先完善后再提交');
            return;
        }
        if (isLengthExceed) {
            message.warning('单卡title长度不能超过100个字符！');
            return;
        }
        const param = {
            select_yes_ids: allIds,
            select_no_ids: [],
            select_yes_no_phone_number: allNoPhoneNumber,
            select_no_no_phone_number: []
        };
        let warnText = '';

        if (isPhoneInvalid) {
            warnText = '当前存在异常号码，是否确定本页全部审核通过';
        }
        const allPassFetch = async () => {
            const data = await fetchCheckThrough(pageId, param);
            if (data && data.code === 200) {
                message.success('审核提交成功');
                fetchDataDetail();
            }
        };
        if (warnText) {
            Modal.confirm({
                title: '温馨提示',
                content: warnText,
                onOk() {
                    allPassFetch();
                }
            });
        } else {
            allPassFetch();
        }
    };
    const onAllReviewPass = () => {
        Modal.confirm({
            title: '温馨提示',
            content: <div>
                此操作会把该页里<span style={{color: 'red'}}>未选择审核状态</span>
                的数据改为<span style={{color: '#1890ff'}}>通过状态</span>，确认继续吗？
            </div>,
            onOk() {
                sendAllPass();
            }
        });
    };

    return (
        <div className="data-review-detail">
            <div className="review-detail-title">
                <LeftOutlined onClick={backPage}/>
                <span>
                    【{dataDetail.import_name} {dataDetail.data_type}】
                    共{dataDetail.total}条数据，已审核{dataDetail.check_count}条，未审核{dataDetail.uncheck_count}条
                </span>
                <span className="ml50">当前分类状态：{selectStatusFilter(dataDetail.status)}</span>
            </div>
            <div className="btn-group">
                {pageType === '1' && <div className="btn-item">
                    <span>省市：</span>
                    <Select
                        style={{width: 100}}
                        placeholder="请选择"
                        value={provCity}
                        onChange={(e) => selectChange(e, 'provCity')}
                        options={provCityOptions}
                    ></Select>
                </div>}
                {pageType === '2' && <div className="btn-item">
                    <span>分类：</span>
                    <Select
                        style={{width: 100}}
                        placeholder="请选择"
                        value={cateSelect}
                        onChange={(e) => selectChange(e, 'cateSelect')}
                        options={cateSelectOptions}
                    ></Select>
                </div>}
                <div className="btn-item">
                    <span>号码：</span>
                    <Select
                        style={{width: 100}}
                        placeholder="请选择"
                        value={numSelect}
                        options={[
                            {value: '全部', label: '全部'},
                            {value: '有号码', label: '有号码'},
                            {value: '无号码', label: '无号码'}
                        ]}
                        onChange={(e) => selectChange(e, 'numSelect')}
                    ></Select>
                </div>
                <div className="btn-item">
                    <span>审核状态：</span>
                    <Select
                        style={{width: 100}}
                        placeholder="请选择"
                        value={checkSelect}
                        options={checkSelectOptions}
                        onChange={(e) => selectChange(e, 'checkSelect')}
                    ></Select>
                </div>
            </div>
            <div className="review-detail-table">
                <Table
                    bordered
                    dataSource={tableData || []}
                    columns={getColumns()}
                    scroll={{x: 2000}}
                    rowKey="group_id"
                    loading={tableLoading}
                    pagination={{
                        total: dataDetail.query_total,
                        pageSize: pageSize,
                        current: pageCurrent,
                        onChange: onPageChange,
                        position: ['bottomCenter']
                    }}
                />
            </div>
            <div className="verify-btn">
                {(dataDetail.status === 0 || dataDetail.status === 1 || dataDetail.status === 2)
                    && <Button
                        type="primary"
                        disabled={!tableData || tableData.length === 0}
                        onClick={onAllReviewPass}
                    >
                        单页数据一键通过
                    </Button>
                }
            </div>

            <Modal
                title="修改上线信息"
                open={isEditDialogVisible}
                width={900}
                onCancel={handleEditCancel}
                footer={null}
            >
                <div className="data-review-edit-modal">
                    <Form
                        labelCol={{span: 7}}
                        wrapperCol={{span: 17}}
                        onFinish={onEditSubmit}
                        style={{width: 800}}
                        form={form}
                        initialValues={editData}
                    >
                        {pageType === '1' && <FormItem label="抓取title">
                            <div>{editData.grab_title}</div>
                        </FormItem>}
                        {pageType === '2' && <FormItem label="公司名称">
                            <div>{editData.company}</div>
                        </FormItem>}
                        {pageType === '2' && <FormItem label="品牌" name="brand">
                            <Input placeholder="请输入品牌"/>
                        </FormItem>}
                        <FormItem label="地址" name="address">
                            <Input placeholder="请输入地址"/>
                        </FormItem>
                        <FormItem label="省/市/区/街道：">
                            <RegionComp
                                provinceData={areaSelectedValue.province}
                                cityData={areaSelectedValue.city}
                                areaData={areaSelectedValue.district}
                                townData={areaSelectedValue.town}
                                onChange={onRegionChange}
                                onClear={onRegionClear}
                            />
                        </FormItem>
                        <FormItem label="杂质点" name="location">
                            <Input placeholder="请输入杂质点"/>
                        </FormItem>
                        <FormItem label="号码" name="phone_number">
                            <Input placeholder="请输入号码"/>
                        </FormItem>
                        <FormItem label="抓取name" name="grab_name">
                            <Input placeholder="请输入抓取name"/>
                        </FormItem>
                        <FormItem
                            label="单卡title"
                            name="online_title"
                            rules={[{required: true, message: '请输入单卡title'}]}
                        >
                            <Input placeholder="请输入单卡title"/>
                        </FormItem>
                        <FormItem
                            label="title简称"
                            name="title_similar"
                            rules={[{required: true, message: '请输入title简称'}]}
                        >
                            <Input placeholder="请输入title简称"/>
                        </FormItem>
                        <FormItem
                            label="单卡name"
                            name="online_name"
                            rules={[{required: true, message: '请输入单卡name'}]}
                        >
                            <Input placeholder="请输入单卡name"/>
                        </FormItem>
                        <FormItem label="动态核心词" name="dynamic_word">
                            <TagComp
                                tagList={editData.dynamic_word}
                                updateTagList={updateDynamicWord}
                                placeholder="添加动态核心词"
                            />
                        </FormItem>
                        <FormItem
                            label="组卡name"
                            name="show_name"
                            rules={cardType === 'group' ? [{required: true, message: '请输入组卡name'}] : []}
                        >
                            <Input placeholder="请输入组卡name"/>
                        </FormItem>
                        <FormItem
                            label="类别"
                            name="category"
                            rules={cardType === 'group' ? [{required: true, message: '请输入类别'}] : []}
                        >
                            <Input placeholder="请输入类别"/>
                        </FormItem>
                        <FormItem label="科室" name="brand_class">
                            <Input placeholder="请输入科室"/>
                        </FormItem>
                        <FormItem
                            label="服务时间"
                        >
                            <FormItem name="weekStart" noStyle>
                                <Select
                                    style={{width: 100}}
                                    placeholder="请选择"
                                    options={weekOption}
                                    allowClear
                                >
                                </Select>
                            </FormItem>
                            <span> 至 </span>
                            <FormItem name="weekEnd" noStyle>
                                <Select
                                    style={{width: 100}}
                                    placeholder="请选择"
                                    options={weekOption}
                                    allowClear
                                >
                                </Select>
                            </FormItem>
                            <FormItem name="connectTimeValue" noStyle >
                                <RangePicker format="HH:mm" style={{marginLeft: '10px'}}></RangePicker>
                            </FormItem>
                        </FormItem>
                        <FormItem
                            label="词槽"
                            name="word_slot"
                            rules={[{required: true, message: '请输入词槽'}]}
                        >
                            <TagComp
                                tagList={editData.word_slot}
                                updateTagList={updateTagList}
                                placeholder="添加词槽"
                            />
                        </FormItem>
                        {editData.dataSourceName === '官网' && <FormItem
                            label="官网链接"
                            name="dataSourceLink"
                            rules={editData.dataSourceName === '官网' ? [{required: true, message: '请输入官网链接'}] : []}
                        >
                            <Input placeholder="请输入官网链接"/>
                        </FormItem>}
                        <FormItem label="审核状态" name="verifyResult">
                            <RadioGroup>
                                <Radio value={1}>通过</Radio>
                                <Radio value={2}>不通过</Radio>
                            </RadioGroup>
                        </FormItem>
                        <Form.Item wrapperCol={{offset: 8, span: 16}}>
                            <Button onClick={handleEditCancel} style={{marginRight: '20px'}}>
                                取消
                            </Button>
                            <Button type="primary" htmlType="submit">
                                确定
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        appealData: state.appealReducer
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchDataReviewDetail: (param) => fetchDataReviewDetail(dispatch, param),
        fetchDetailUpdate: (id, param) => fetchReviewDetailUpdate(dispatch, id, param),
        fetchCheckThrough: (id, param) => fetchReviewCheckThrough(dispatch, id, param),
        fetchFilterList: (param) => fetchReviewFilterList(dispatch, param)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataReviewDetail as any));
